<!--
 * @Description: 画世界Pro官网首页-简版
 * @Author: Rfan
 * @Date: 2020-11-03 12:03:32
 * @LastEditTime: 2024-12-20 11:08:21
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: "PandaPaint",
  data(){
    return {
      isWebp:false
    }
  },
  created() {
    async function supportsWebp() {
      if (!self.createImageBitmap) return false;

      const webpData =
        "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=";
      const blob = await fetch(webpData).then((r) => r.blob());
      return createImageBitmap(blob).then(
        () => true,
        () => false
      );
    }

    (async () => {
      if (await supportsWebp()) {
        console.log("does support");
        this.$root.isWebp=true
      } else {
        console.log("does not support");
        this.$root.isWebp=false
      }
    })();
  },
};
</script>

<style lang="scss">
html,body{
  height: 100%;
}
#app {
  height: 100%;
  overflow: auto;
  background-color: #f5f7fa;
  font-family: "Helvetica Neue", "Helvetica", "PingFang SC", "Microsoft YaHei",
    "Hiragino Sans GB", "SimSun", "sans-serif";
}
</style>
